
import "../Foundation/stylable/shadows.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_139_1_CarouselWIP";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_139_1_CarouselWIP__root","carousel":"wds_1_139_1_CarouselWIP__carousel","control":"wds_1_139_1_CarouselWIP__control","prev":"wds_1_139_1_CarouselWIP__prev","next":"wds_1_139_1_CarouselWIP__next","start":"wds_1_139_1_CarouselWIP__start","end":"wds_1_139_1_CarouselWIP__end","dots":"wds_1_139_1_CarouselWIP__dots","dot":"wds_1_139_1_CarouselWIP__dot","loader":"wds_1_139_1_CarouselWIP__loader"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"horizontalSpacingSize":"50px","verticalSpacingSize":"7px"}; 
export var vars = {"arrow-size":"--wds_1_139_1_CarouselWIP-arrow-size","sidesGradientColor":"--wds_1_139_1_CarouselWIP-sidesGradientColor"}; 




